import { env } from 'config/env';
import { UserManagerSettings } from 'oidc-client-ts';

const redirectUri = `${env.VITE_APP_URL}/signin-oidc`;

const localSettings: UserManagerSettings = {
  client_id: env.VITE_OIDC_CLIENT_ID,
  authority: env.VITE_OIDC_AUTHORITY,
  client_secret: env.VITE_OIDC_CLIENT_SECRET,
  extraTokenParams: { company_id: '' },
  response_type: 'code',
  redirect_uri: redirectUri,
  scope: 'openid profile RopeAPI offline_access',
};

export { localSettings };
